import { BILLING_PERIODS } from "@biteasy/contracts";
import { createFileRoute, redirect } from "@tanstack/react-router";
import z from "zod";
import { authClient } from "@/auth";
import { orpc } from "@/orpc/client";
import { CheckoutPage } from "@/pages/checkout/CheckoutPage";

const CheckoutSearchSchema = z.object({
	plan: z.enum(["bootstrap", "standard", "scale"]).default("standard"),
	billingPeriod: z.enum(BILLING_PERIODS).default("monthly"),
});

export const Route = createFileRoute("/checkout")({
	validateSearch: CheckoutSearchSchema,
	beforeLoad: async () => {
		const { data: authSession } = await authClient.getSession();

		if (!authSession?.user) {
			throw redirect({ to: "/auth/signin" });
		}

		return { authSession };
	},
	loaderDeps: ({ search }) => ({
		plan: search.plan,
		billingPeriod: search.billingPeriod,
	}),
	loader: ({ context: { queryClient }, deps: input }) =>
		queryClient
			.ensureQueryData(
				orpc.billing.createEmbeddedCheckoutSession.queryOptions({ input }),
			)
			.catch((error) => {
				throw error instanceof Error && error.message.includes("already active")
					? redirect({ to: "/dashboard" })
					: error;
			}),
	head: () => ({
		meta: [{ title: "Checkout - BitEasy" }],
	}),
	component: CheckoutPage,
});
